function modal() {
	
	var $venueBtns = document.querySelectorAll('.listing-venue-item--btn'),
		$modalHld = document.querySelector('.modal-hld-container'),
		$modalClose = document.querySelector('.modal-close');

	if($venueBtns) {
		for(var i=0; i < $venueBtns.length; i++) {
			$venueBtns[i].addEventListener('click', function() {
				var index = $('.listing-venue-item--btn').index(this);

				$modalHld.parentNode.classList.add('active');

				$('.contactConference select').SumoSelect();
				$('.contactConference select')[0].sumo.selectItem(index);
			});
		}
	}

	$modalHld.addEventListener('click', function() {
		this.parentNode.classList.remove('active');
	});

	$modalClose.addEventListener('click', function() {
		$modalHld.parentNode.classList.remove('active');
	});

};

module.exports = modal;